import { useState, useEffect } from 'react';
import { db } from '../../../firebase/config';
import {
  collection, doc, onSnapshot, query, orderBy, limit,
  getDocs, getDoc,
} from 'firebase/firestore';
import { useAuth } from '../../../contexts/AuthContext';

export function useIsApplabAdmin() {
  const { currentUser } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) { setLoading(false); return; }
    getDoc(doc(db, 'applab_admins', currentUser.uid))
      .then(snap => setIsAdmin(snap.exists()))
      .catch(() => setIsAdmin(false))
      .finally(() => setLoading(false));
  }, [currentUser]);

  return { isAdmin, loading };
}

export function useApplabConfig() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    return onSnapshot(doc(db, 'applab_config', 'global'), snap => {
      setConfig(snap.exists() ? { id: snap.id, ...snap.data() } : null);
    });
  }, []);

  return config;
}

export function useApplabQuotas() {
  const [quotas, setQuotas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDocs(collection(db, 'applab_quotas')).then(snap => {
      const rows = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      rows.sort((a, b) => (b.tokens_used_this_month || 0) - (a.tokens_used_this_month || 0));
      setQuotas(rows);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return { quotas, loading, refetch: () => setLoading(true) };
}

export function useApplabUsage() {
  const [usage, setUsage] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, 'applab_usage'), orderBy('timestamp', 'desc'), limit(100));
    return onSnapshot(q, snap => {
      setUsage(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setLoading(false);
    }, () => setLoading(false));
  }, []);

  return { usage, loading };
}
